export default __webpack_public_path__ + "static/media/kong.3d035038.svg";